export function prettifyFieldKey(key: string): string {
  if (!key) return '';
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/[_\-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^./, s => s.toUpperCase());
}

export function maskSensitiveValue(key: string, value: any): any {
  const k = (key || '').toLowerCase();

  if (value === null || value === undefined) return value;

  if (
    k.includes('accountnumber') ||
    k.includes('iban') ||
    k.includes('phone') ||
    k.includes('walletid')
  ) {
    const str = String(value);
    if (str.length <= 4) return str;
    return `${'*'.repeat(Math.max(0, str.length - 4))}${str.slice(-4)}`;
  }

  return value;
}